
<div class="timeline-item-badge">{{'poll_results' | translate }}</div>
    
<div class="card-top" [ngClass]="{'recurring-poll': task.isRecurring}">
    <div class="pt-2 pe-2">
        <i class="fa-sharp-duotone fa-solid fa-chart-simple fa-2x ms-2 pt-1 position-relative"></i>
    </div>

    <div class="card-comment p-3" [ngClass]="{'not-recurring-poll': !task.isRecurring}">
        <p class="card-comment-body fst-italic">{{task.label}}</p>

        <mat-tab-group (selectedTabChange)="onTabChanged($event);">
            <mat-tab [label]="resultsTabLabel">
                <ng-template matTabContent>
                    @if(participationCount > 0){
                        @if(participationCount !== dontWantToAnswerItem.count){
                            <div class="result-container">
                                <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
                                <div class="score">{{average.averageScore}} <sub>/5</sub></div>
                            </div>
                            <p class="infos pb-2">
                                @if(average.people === 1){
                                    {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answer' | translate}}
                                }@else{
                                    {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answers' | translate}}
                                }
                                @if(dontWantToAnswerItem.count > 0){
                                    <small class="d-block">
                                        {{'poll_results.stars_additionally' | translate}} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
                                        @if(dontWantToAnswerItem.count === 1){
                                            {{'poll_results.stars_time' | translate}}
                                        }@else{
                                            {{'poll_results.stars_times' | translate}}
                                        }
                                    </small>
                                }
                            </p>
                        }@else {
                            <div class="alert alert-warning pb-1">
                                <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
                                <div class="text-center fs-6 fst-italic">{{'poll_results.stars_no-answer' | translate}}</div>
                            </div>
                            <small class="d-block text-center fs-6 fst-italic">
                                {{ 'poll_results.stars_option' | translate }} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
                                @if(dontWantToAnswerItem.count === 1){
                                    {{'poll_results.stars_time' | translate}}
                                }@else{
                                    {{'poll_results.stars_times' | translate}}
                                }
                            </small>
                        }
                    }@else{
                        <div class="alert alert-warning mt-2 mb-0 fs-6 fst-italic">
                            {{'poll_results.no_data'| translate}}
                        </div>
                    }
                </ng-template>
            </mat-tab>

            <mat-tab [label]="trendsTabLabel" [disabled]='!task.isRecurring'>
                <ng-template matTabContent>
                    @if(tabIndexToShow === 1){
                        <recurring-poll-result-trends [poll]="task"></recurring-poll-result-trends>
                    }
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    
    <div class="card-options">
        <div data-cy="report-comment" (click)="reportItem()">
            <i class="fa-regular fa-hexagon-exclamation"
               [matTooltip]="'comment-card.options.report' | translate"
               matTooltipPosition="right"></i>
        </div>
    </div>
</div>
<div class="card-result-comments">
    <poll-result-comments [commentResults]="task.results.values"
                          [itemType]="task.itemType"></poll-result-comments>
</div>

                    